import { render, staticRenderFns } from "./SupportListFilters.vue?vue&type=template&id=dc1d20aa"
import script from "./SupportListFilters.vue?vue&type=script&lang=js"
export * from "./SupportListFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports